import { Action } from 'redux';
import { PrebuildModule } from '@dev/ee-api/ee-api-models';

export enum ActionTypes {
    LOAD_START = '@@prebuildModules/LOAD_START',
    LOAD_SUCCESS = '@@prebuildModules/LOAD_SUCCESS',
    LOAD_ERROR = '@@prebuildModules/LOAD_ERROR',
    ADD_START = '@@prebuildModules/ADD_START',
    ADD_SUCCESS = '@@prebuildModules/ADD_SUCCESS',
    ADD_ERROR = '@@prebuildModules/ADD_ERROR',
    EDIT_START = '@@prebuildModules/EDIT_START',
    EDIT_SUCCESS = '@@prebuildModules/EDIT_SUCCESS',
    EDIT_ERROR = '@@prebuildModules/EDIT_ERROR',
    DELETE_START = '@@prebuildModules/DELETE_START',
    DELETE_SUCCESS = '@@prebuildModules/DELETE_SUCCESS',
    DELETE_ERROR = '@@prebuildModules/DELETE_ERROR',
}

export interface PrebuildModulesLoadAction extends Action {
    type: ActionTypes.LOAD_START;
}

export interface PrebuildModulesLoadSuccessAction extends Action {
    type: ActionTypes.LOAD_SUCCESS;
    payload: { list?: PrebuildModule[] };
}

export interface PrebuildModulesLoadErrorAction extends Action {
    type: ActionTypes.LOAD_ERROR;
}

export interface PrebuildModulesAddStartAction extends Action {
    type: ActionTypes.ADD_START;
    payload: { module: PrebuildModule };
}

export interface PrebuildModulesAddSuccessAction extends Action {
    type: ActionTypes.ADD_SUCCESS;
    payload: { list: PrebuildModule[] };
}

export interface PrebuildModulesEditStartAction extends Action {
    type: ActionTypes.EDIT_START;
    payload: { id: string, newName: string };
}

export interface PrebuildModulesEditSuccessAction extends Action {
    type: ActionTypes.EDIT_SUCCESS;
    payload: { list: PrebuildModule[] };
}

export interface PrebuildModulesDeleteStartAction extends Action {
    type: ActionTypes.DELETE_START;
    payload: { id: string };
}

export interface PrebuildModulesDeleteSuccessAction extends Action {
    type: ActionTypes.DELETE_SUCCESS;
    payload: { list: PrebuildModule[] };
}

export interface PrebuildModulesState {
    list: PrebuildModule[];
    isLoading: boolean;
    isLoaded: boolean;
    isError: boolean;
}
